var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"report-btn",attrs:{"to":{ name: 'ReportProblem' }}},[_vm._v("Sorun Bildir")])}
var staticRenderFns = []

export { render, staticRenderFns }